var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('collapseTransition',[(_vm.isShow)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"docs"},[_vm._t("highlight")],2)]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"docs-trans",on:{"click":function($event){_vm.isShow = !_vm.isShow}}},[_vm._v(_vm._s(_vm.isShow ? '隐藏代码' : '显示代码'))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-55308a55","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/demo-block.vue
// module id = null
// module chunks = 